import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { useEventContext } from '../../contexts/EventContext';
import { EventModalNavigationState } from './EventModalTypes';
import { useTranslation } from 'react-i18next';

export const EventInformationModalContent = ({ changeModalState }: { changeModalState: (state: EventModalNavigationState) => void }) => {
    const eventsContext = useEventContext();
    const { t } = useTranslation();

    const selectedEvent = eventsContext.selectedEvent;

    if (!selectedEvent) {
        return (<></>);
    }

    return (
        <>
            <Grid container spacing={2} mt={2}>
                <Grid size={1}>
                    <AccessTimeIcon />
                </Grid>
                <Grid size={11}>
                    {selectedEvent.startTime}-{selectedEvent.endTime}
                </Grid>
                {selectedEvent.location &&
                    <>
                        <Grid size={1}>
                            <MapOutlinedIcon />
                        </Grid>
                        <Grid size={11}>
                            <span dangerouslySetInnerHTML={{ __html: selectedEvent.location }}></span>
                        </Grid>
                    </>
                }
                <Grid size={1}>
                    <InfoOutlineIcon />
                </Grid>
                <Grid size={11}>
                    <Typography dangerouslySetInnerHTML={{ __html: selectedEvent.description.replaceAll("\n", "<br>") }}></Typography>
                </Grid>
                {selectedEvent.booking &&
                    <>
                        <Grid size={1}>
                            <PersonOutlinedIcon />
                        </Grid>
                        <Grid size={11}>
                            {selectedEvent.booking.bookingInfo || t("event_info.not_booked")}
                        </Grid>
                    </>
                }
                {selectedEvent.booking?.partnerBookingInfo &&
                    <>
                        <Grid size={1}>
                            <PeopleOutlineIcon />
                        </Grid>
                        <Grid size={11}>
                            {selectedEvent.booking.partnerBookingInfo}
                        </Grid>
                    </>
                }
            </Grid>
        </>
    );
}
